import { TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { PricingStrategy } from 'shared'
import { SetState } from 'types'

interface FinalizePresenterProps {
  setStrategy: SetState<PricingStrategy>
  strategy: PricingStrategy
}

export const FinalizePresenter = ({
  strategy,
  setStrategy,
}: FinalizePresenterProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <p className="mb-2">{t('strategy.create.almostDone')}</p>
      <TextField
        fullWidth
        value={strategy.name}
        autoFocus
        onFocus={(event) => event.target.select()}
        onChange={(e) =>
          setStrategy({
            ...strategy,
            name: e.target.value,
          })
        }
        label={t('strategy.name')}
        data-testid="pricing-strategy-name"
      />
    </>
  )
}
